<template>
  <div class="Notebook">
    <TextAreaInput
      :value="note"
      :resizable="true"
      @resize="resize"
      @resizedone="resizedone"
      placeholder="Skriv anteckningar här..."
      @input="updateNotesDebounced"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from "debounce";
import TextAreaInput from "@/components/forms/TextAreaInput";

export default {
  name: "ApplicationNotebook",
  components: {
    TextAreaInput
  },
  props: {
    isApplicationNote: {
      type: Boolean,
      default: true
    },
    note: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {},
  methods: {
    ...mapActions("applicationStore", ["updateNote", "updateActionNote"]),
    updateNotes(data) {
      if (this.isApplicationNote) {
        this.updateNote(data);
      } else {
        this.updateActionNote(data);
      }
    },
    updateNotesDebounced: debounce(function(value) {
      this.updateNotes({ note: value, id: this.id });
    }, 1000),
    resize() {
      this.$emit("resize");
    },
    resizedone() {
      this.$emit("resizedone");
    }
  }
};
</script>

<style lang="scss" scoped>
.Notebook {
  padding-top: $spacing-L;

  .Action-item__content__inner & {
    padding-top: $spacing;
  }

  .Form-input {
    @extend %paragraph;
  }
}
</style>
